import { Injectable, inject } from '@angular/core';
import { DirtyCheckPlugin, Query } from '@datorama/akita';

import { LoanApplicationModel } from '../../models/loan-application.model';
import { LoanApplicationStore } from './loan-application.store';
import { filter } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoanApplicationQuery extends Query<LoanApplicationModel> {
  protected store: LoanApplicationStore;

  dirtyCheck = new DirtyCheckPlugin(this);

  constructor() {
    const store = inject(LoanApplicationStore);

    super(store);

    this.store = store;
  }

  selectLoanApplication() {
    return this.select().pipe(
      //  Only emit when fileDataId is something
      filter((state) => !!state.fileDataId),
    );
  }
}
